namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201_RecvForm {
    }

    export class Report_1201_RecvForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1201_Recv';
    }
}
